import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { InvoiceStepButton } from 'src/components/InvoiceStepButton';
import { routes } from 'src/routes';

import { useInvoiceDetailsQuery } from './billingApi';

export const BillingProcessSteps = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { data: invoiceData, isLoading } = useInvoiceDetailsQuery(id!, {
    skip: !id,
  });

  const seitStatus = invoiceData?.seitStatus;

  const handleConfirmSessionsClick = () => {
    navigate(
      `${routes.billing.root}/${routes.billing.confirmSessions.root.replace(':id', id || '')}`,
    );
  };

  const handleLogCoordinationClick = () => {
    navigate(
      `${routes.billing.root}/${routes.billing.logCoordination.root.replace(':id', id || '')}`,
    );
  };

  const handleLogServicesClick = () => {
    navigate(`${routes.billing.root}/${routes.billing.logServices.root.replace(':id', id || '')}`);
  };

  const isConfirmSessionsSelected = pathname.includes('confirm-sessions');
  const isLogCoordinationSelected = pathname.includes('log-coordination');
  const isLogServicesSelected = pathname.includes('log-services');

  const confirmSessionsState = (() => {
    if (!seitStatus?.sessionsStepStarted && !seitStatus?.sessionsStepCompleted) {
      return 'incomplete';
    } else if (!seitStatus?.sessionsStepCompleted) {
      return 'in-progress';
    } else {
      return 'complete';
    }
  })();

  const logCoordinationState = (() => {
    if (!seitStatus?.activitiesStepStarted && !seitStatus?.activitiesStepCompleted) {
      return 'incomplete';
    } else if (!seitStatus?.activitiesStepCompleted) {
      return 'in-progress';
    } else {
      return 'complete';
    }
  })();

  const logServicesState = (() => {
    if (!seitStatus?.servicesStepStarted && !seitStatus?.servicesStepCompleted) {
      return 'incomplete';
    } else if (!seitStatus?.servicesStepCompleted) {
      return 'in-progress';
    } else {
      return 'complete';
    }
  })();

  return (
    !isLoading && (
      <div className="flex flex-col gap-2 border-neutral-800 2xl:border-l 2xl:pl-6">
        <InvoiceStepButton
          variant={confirmSessionsState}
          label="Confirm Sessions"
          onClick={handleConfirmSessionsClick}
          isSelected={isConfirmSessionsSelected}
        />
        <InvoiceStepButton
          variant={logCoordinationState}
          label="Log Coordination"
          onClick={handleLogCoordinationClick}
          isSelected={isLogCoordinationSelected}
        />
        <InvoiceStepButton
          variant={logServicesState}
          label="Log Services"
          onClick={handleLogServicesClick}
          isSelected={isLogServicesSelected}
        />
      </div>
    )
  );
};
